import { Log, User } from "src/types.g";

export interface LogDetailsProps {
  log: Partial<Log>;
  user: User | null | undefined;
}

// Utility to get all unique keys from both objects
export const getAllKeys = (a: Record<string, any>, b: Record<string, any>) =>
  Array.from(
    new Set([...(a ? Object.keys(a) : []), ...(b ? Object.keys(b) : [])]),
  );

export function parseIfJsonString(val: unknown) {
  if (typeof val === "string") {
    try {
      const parsed = JSON.parse(val);
      if (typeof parsed === "object" && parsed !== null) {
        return parsed;
      }
    } catch {
      // Not JSON, return as is
    }
  }
  return val;
}

export const isCreateAction = (action: string) => action === "I";
export const isDeleteAction = (action: string) => action === "D";
export const isUpdateAction = (action: string) => action === "U";
